// remove date with 1 pax remaining if tour
// does not allow solo travel
import type { VisibleDate } from '$saga/views/Tour/VisibleDates/types';

export const filterTourDatesIsTravelAloneAuthorized = (
    dates: VisibleDate[],
    isTravelAloneAuthorized: boolean,
) => {
    return isTravelAloneAuthorized
        ? dates
        : dates.filter((date) => !date.isFull && date.remaining_stock > 1);
};
